import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface AvailableLockSystem {
  system: string;
  label: string;
  fields: {
    field_name: string;
    field_label: string;
    field_type: string;
    required: boolean;
  }[];
}

export interface LockSystem {
  id: number;
  display_name: string;
  business_profile_id: number;
  type: string;
  credentials: {
    [key: string]: string;
  };
}

export type CreateLockSystem = Omit<LockSystem, "id">;
export type UpdateLockSystem = Partial<LockSystem>;

export function LockSystemsAPI(baseUrl: string) {
  return {
    list: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/lock-systems/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<LockSystem[]>;
    },
    get: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/lock-systems/${id}?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<LockSystem>;
    },
    update: async (id: number, lockSystemData: UpdateLockSystem) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.put(
        `${baseUrl}/lock-systems/${id}?business_profile_id=${businessProfileId}`,
        lockSystemData,
        true,
      )) as ApiResponse<LockSystem>;
    },
    create: async (lockSystemData: CreateLockSystem) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/lock-systems?business_profile_id=${businessProfileId}`,
        lockSystemData,
        true,
      )) as ApiResponse<LockSystem>;
    },
    getAvailableLockSystems: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/lock-systems/get-available-systems/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<{ schemas: AvailableLockSystem[] }>;
    },
    delete: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.delete(
        `${baseUrl}/lock-systems/${id}?business_profile_id=${businessProfileId}`,
        true,
      )) as ApiResponse<object>;
    },
  };
}
